<template>
  <div>
    <ts-page-title
      :title="$t('certificateOperationPrint.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('certificateOperationPrint.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('certificateOperationPrint.search')"
            :placeholder="$t('certificateOperationPrint.search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'requesting_date',
          }"
        >
          <template v-slot="{ record }">
            <!-- <td class="tw-whitespace-nowrap">
              {{ record.candidates.card_number }}
            </td> -->
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.candidates.full_name_en }}
            </td>
            <td class="tw-whitespace-nowrap tw-text-center">
              {{ record.candidates.sex }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.candidates.phone }}</td>
            <td class="tw-whitespace-nowrap">
              {{ record.certificate_number }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.level_skill_name }} | Level:
              {{ record.skill_level_order }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.cert_type_name }}</td>
            <td class="tw-text-center tw-items-center w-whitespace-nowrap">
              <a-switch
                :disabled="!record.is_printed"
                :loading="waiting"
                v-model="record.reach_candidate"
                size="small"
                @change="onSwitch(record)"
              />
            </td>
            <td class="tw-text-center tw-items-center w-whitespace-nowrap">
              <span class="tw-text-green-500" v-if="record.is_approved">
                <a-icon type="check-circle" class="tw-text-lg" />
              </span>
              <span v-else class="tw-text-red-500">
                <a-icon type="close-circle" class="tw-text-lg" />
              </span>
            </td>
            <td class="tw-text-center w-whitespace-nowrap">
              {{ record.approved_by }}
            </td>
            <td class="tw-text-center w-whitespace-nowrap">
              {{ record.approved_date }}
            </td>
            <td class="tw-text-center w-whitespace-nowrap">
              {{ record.printed_by }}
            </td>
            <td class="tw-text-center w-whitespace-nowrap">
              {{ record.updated_at }}
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                v-if="record.is_approved && !record.is_printed"
                href="#"
                v-tooltip="$t('accessorCertificateRequest.print')"
                class="text-blue mr-2"
                @click.prevent="print(record)"
              >
                <i class="fas fa-print"></i>
              </a>
              <a
                v-if="!record.is_approved"
                href="#"
                v-tooltip="$t('certificateOperationPrint.approved')"
                class="text-primary mr-2"
                @click.prevent="approved(record)"
              >
                <i class="fas fa-check"></i>
              </a>
              <!-- <a
                v-if="!record.is_approved"
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a> -->
              <a-popconfirm
                v-if="!record.is_approved"
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
    </a-drawer>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('certificateOperationPrint.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="1080px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
    <a-modal
      v-if="showFormEdit"
      v-model="showFormEdit"
      :title="$t('certificateOperationPrint.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="1080px"
    >
      <from-edit-action @cancel="clearEdit" />
    </a-modal>
    <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions, mapState } from "vuex";
import FromAction from "./form.vue";
import FromEditAction from "./form-edit.vue";
import { Errors } from "form-backend-validation";
export default {
  name: "certificateOperationPrintIndex",
  components: {
    FromAction,
    FromEditAction,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      src: "",
      showForm: false,
      showFormEdit: false,
      show_pdf: false,
      visible: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("academic/certificateOperationPrint", [
      "resources",
      "pagination",
    ]),
    search: {
      get() {
        return this.$store.state.academic.certificateOperationPrint.search;
      },
      set(newValue) {
        this.$store.commit(
          "academic/certificateOperationPrint/SET_SEARCH",
          newValue
        );
        this.$store.commit(
          "academic/certificateOperationPrint/RESET_CURRENT_PAGE"
        );
      },
    },
    columns() {
      return [
        // {
        //   name: this.$t("certificateOperationPrint.cardNumber"),
        //   style: "white-space: nowrap;",
        // },
        {
          name: this.$t("certificateOperationPrint.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.nameEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.sex"),
          style: "white-space: nowrap;text-align:center",
        },
        {
          name: this.$t("certificateOperationPrint.phone"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.certificateNumber"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.levelSkill"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.certType"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.reachCandidate"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.isApproved"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.approvedBy"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.approvedDate"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.printedBy"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("certificateOperationPrint.printedAt"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 5%;",
        },
      ];
    },
  },
  methods: {
    ...mapActions("academic/certificateOperationPrint", ["approve"]),
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    async onSwitch(record) {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/reachCandidate", {
          id: record.printing_id,
          data: { reach_candidate: record.reach_candidate },
        })
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.fetchData();
          this.$router.push({ name: "certificate-operation-print" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit(
        "academic/certificateOperationPrint/SET_EDIT_DATA",
        record
      );
      this.showFormEdit = true;
    },
    approved(record) {
      this.$router.push({
        name: "certificate-operation-print-approve",
        params: {
          candidate_id: record.candidate_id,
          exam_register_id: record.exam_register_id,
          printing_id: record.printing_id,
          certificate_id: record.certificate_id,
        },
      });
    },
    async clearEdit() {
      await this.$store.commit(
        "academic/certificateOperationPrint/SET_EDIT_DATA",
        {}
      );
      await this.fetchData();
      this.showForm = false;
      this.showFormEdit = false;
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch(
          "academic/certificateOperationPrint/destroy",
          record.printing_id
        )
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
    print(record) {
      this.show_pdf = true;
      this.waiting = true;
      this.src = "";
      this.$store
        .dispatch("academic/certificateOperationPrint/printPdf", {
          printing_id: record.printing_id,
        })
        .then((response) => {
          this.src = response.url;
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/certificateOperationPrint/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
